/*
 * Copyright 2022 Oriflame
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Best-effort Title-Case for a raw catalog entity ref name, used **only** as a
 * fallback when the entity has no `metadata.title`. Splits on `-`, `_`, `.` and
 * whitespace and capitalises each word: `docu-synth` → `Docu Synth`.
 *
 * It cannot recover intended casing that only lives in `metadata.title`
 * (`prm` → `Prm`, not `PRM`) — the real fix is resolving the catalog title (see
 * {@link ScoringDataJsonClient}); this just makes the title-less remainder read
 * a little better than a bare lowercase slug.
 */
export function humanizeEntityName(name: string): string {
  if (!name) {
    return name;
  }
  return name
    .split(/[-_.\s]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
